/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".intersection{min-height:255px}.intersection .input-container{margin-bottom:15px}.intersection .result{margin-bottom:5px;cursor:pointer;padding-left:5px}.intersection .result .primary-text{font-weight:700}.intersection .result:hover{background-color:#f8f8f8}.intersection .selected-result{background-color:#0079c1;color:#fff}.intersection .selected-result .result:hover{background-color:#0079c1}"];
export { styles as styles };
